import { useCallback } from 'react';
import { useAuthModal } from '@features/common/protected-auth-route/model.ts';
import { Like, Liked } from '@shared/assets/index.ts';
import { useUser } from '@shared/hooks/index.ts';
import * as shared from '../styles.module.scss';

type PT = {
  likesCount: number;
  onLike: () => void;
  onRemoveLike: () => void;
  isLiked?: boolean;
};

export const LikesSmallButton = ({ onRemoveLike, onLike, isLiked, likesCount }: PT) => {
  const { isAuth } = useUser();
  const { openAuth } = useAuthModal();
  const onButtonClick = useCallback(() => {
    if (isAuth) {
      isLiked ? onRemoveLike() : onLike();
    } else {
      openAuth();
    }
  }, [isAuth, isLiked, onRemoveLike, onLike, openAuth]);
  return (
    <button className={shared.button} onClick={onButtonClick}>
      {isLiked ? <Liked /> : <Like />}
      <p>{likesCount}</p>
    </button>
  );
};
